import {Component} from '@angular/core';
import { AppComponent } from 'src/app/app.component';

@Component({
    selector: 'app-footer',
    template: `
        <div class="layout-footer">
            <div class="footer-logo-container"></div>
            <span class="copyright">2019 - 2023 Air Paperless - By Henry Schein One Italia S.r.l.  |  Scopri gli altri prodotti Orisline</span>
        </div>
    `,
    styleUrls: ['./app.footer.component.scss']
})
export class AppFooterComponent {
    constructor(public app: AppComponent) {}
}
